import { render, staticRenderFns } from "./DropdownItemDelete.vue?vue&type=template&id=fc9c6c7a&scoped=true&"
import script from "./DropdownItemDelete.vue?vue&type=script&lang=js&"
export * from "./DropdownItemDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9c6c7a",
  null
  
)

export default component.exports